<script setup>
  import { computed, useAttrs } from "vue";

  const attrs = useAttrs();
  const props = defineProps({
    containerClass: {
      type: String,
      default: "",
    },
    total: {
      type: Number,
    },
    totalCountUnit: {
      type: String,
      default: "건",
    },
  });
  const filteredAttrs = computed(() => {
    const { containerClass, showTotalCount, totalCountUnit, ...others } = attrs;
    return others;
  });
</script>

<template>
  <div :class="containerClass">
    <n-flex
      :wrap="false"
      align="flex-end"
      justify="space-between"
      class="mb-4"
      v-if="total != null || $slots.tableRightTop"
    >
      <p v-if="total != null" class="font-bold text-gray-700">
        총 <strong class="text-primary-500">{{ total }}</strong
        >{{ totalCountUnit }}
      </p>
      <slot name="table-right-top"></slot>
    </n-flex>
    <n-data-table
      class="ui-data-table"
      :bordered="false"
      :single-line="true"
      style="
        --n-border-color: var(--smoe-border);
        --n-border-color-modal: var(--smoe-border);
        --n-border-radius: 0;
        --n-font-size: 1rem;
        --n-line-height: 1.25;
        --n-merged-td-color-sorting: var(--smoe-gray-50);
        --n-merged-th-color-sorting: var(--smoe-gray-50);
        --n-td-color-hover: var(--smoe-gray-50);
        --n-td-padding: 0.5rem 0.75rem;
        --n-td-text-color: var(--smoe-gray-800);
        --n-th-color: var(--smoe-primary-50);
        --n-th-color-modal: var(--smoe-primary-50);
        --n-th-padding: 0.75rem;
        --n-th-text-color: var(--smoe-gray-800);
      "
      :pagination="{
        pageSize: 10,
        ...$attrs.pagination,
      }"
      v-bind="filteredAttrs"
    >
      <slot />
    </n-data-table>
  </div>
</template>

<style lang="scss">
  .n-data-table.ui-data-table {
    border-top: 1px solid var(--smoe-black);
    .n-data-table-th {
    }
    .n-data-table-td {
      height: 56px;
      .n-button.ui-button {
        min-width: 80px;
      }
    }
    .n-data-table-th {
      white-space: pre-line;
    }
    tr.selected {
      th,
      td {
        background: var(--smoe-primary-50) !important;
      }
    }
  }
</style>
